<template>
  <v-app
    v-cloak
    id="main-layout">
    <core-toolbar
      v-if="currentUser.isLoggedIn"
      :user="currentUser"
      is-admin="isAdmin"/>
    <core-drawer
      v-if="currentUser.isLoggedIn"
      :user="currentUser"
      is-admin="isAdmin"/>
    <slot />
    <core-loading />
    <core-idle />
    <core-snackbar />
    <core-dialog />
    <core-server-error-dialog />
    <core-dialog-email />
    <div v-if="isAdmin && currentUser.isLoggedIn && currentUser.view === 'admin'">
      <form-admin-account-dialog />
      <form-admin-master-payer/>
      <form-admin-customer-dialog />
      <form-admin-finance-dialog />
      <form-change-log />
      <core-actions />
    </div>
  </v-app>
</template>
<script>
import { mapState } from 'vuex'
import { TokenService } from '@/services/storage.service'

export default {
  computed: {
    ...mapState(['currentUser']),
    isAdmin () {
      if (this.currentUser.view === 'admin') {
        return true // isAdmin()
      }
    }
  },
  mounted () {
    if (this.$store.state.initialLoad && window.refreshInterval === undefined) {
      if (TokenService.getToken() && !TokenService.isTokenExpired()) {
        if (this.currentUser.view === 'admin') {
          this.$store.dispatch('admin/init')
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .v-datatable .current-item, .v-datatable .current-item td {
    background: #41B3DF !important;
  }

  .v-datatable .current-item:hover {
    background: #41B3DF !important;
  }

  .v-datatable tr th:nth-child(1), .v-datatable tr td:nth-child(1) {
    position: sticky;
    left: 0px;
    z-index: 3;
    background: #fff;
  }

  .v-data-table th {
    position: sticky;
    top: 0;
    background: #fff;
    border-bottom: 1px solid #eee;
  }

  table.v-table tbody td {
    background: #fff;
  }

  .required {
    color:#f44336;
  }
</style>
